import watchUpdateDatalimit from './updateDatalimit';
import watchSetDatalimit from './setDatalimit';

const watchEditDatalimit = [watchUpdateDatalimit, watchSetDatalimit];

export default watchEditDatalimit;
